var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: require("./image/workshop/bg.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "center"
  }, [_c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside1.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "center-content"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("div", {
    staticClass: "item item-1"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("用电量")]), _c("div", {
    staticClass: "item-content",
    staticStyle: {
      "padding-bottom": "1.57vh"
    }
  }, [_c("img", {
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748569833181.png",
      alt: ""
    }
  }), _c("div", [_c("div", {
    staticClass: "opt"
  }, [_vm._m(0), _c("div", {
    staticClass: "opt-right"
  }, [_c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalData.today)), _c("span", [_vm._v("kwh")])]), _vm.totalData.todayRate == "--" || _vm.totalData.todayRate >= 0 ? _c("div", {
    staticClass: "label label-1"
  }, [_vm._v("较昨日增加"), _c("span", [_vm._v(_vm._s(_vm.totalData.todayRate) + "%")]), _vm.totalData.todayRate > 0 ? _c("img", {
    attrs: {
      src: require("./image/largeEnergy/add.png"),
      alt: ""
    }
  }) : _vm._e()]) : _c("div", {
    staticClass: "label label-2"
  }, [_vm._v("较昨日减少"), _c("span", [_vm._v(_vm._s(Math.abs(_vm.totalData.todayRate)) + "%")]), _c("img", {
    attrs: {
      src: require("./image/largeEnergy/reduce.png"),
      alt: ""
    }
  })])])]), _c("div", {
    staticClass: "opt"
  }, [_vm._m(1), _c("div", {
    staticClass: "opt-right"
  }, [_c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalData.month)), _c("span", [_vm._v("kwh")])]), _vm.totalData.monthRate == "--" || _vm.totalData.monthRate >= 0 ? _c("div", {
    staticClass: "label label-1"
  }, [_vm._v("较上月增加"), _c("span", [_vm._v(_vm._s(_vm.totalData.monthRate) + "%")]), _vm.totalData.monthRate > 0 ? _c("img", {
    attrs: {
      src: require("./image/largeEnergy/add.png"),
      alt: ""
    }
  }) : _vm._e()]) : _c("div", {
    staticClass: "label label-2"
  }, [_vm._v("较上月减少"), _c("span", [_vm._v(_vm._s(Math.abs(_vm.totalData.monthRate)) + "%")]), _c("img", {
    attrs: {
      src: require("./image/largeEnergy/reduce.png"),
      alt: ""
    }
  })])])]), _c("div", {
    staticClass: "opt"
  }, [_vm._m(2), _c("div", {
    staticClass: "opt-right"
  }, [_c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalData.year)), _c("span", [_vm._v("kwh")])]), _vm.totalData.yearRate == "--" || _vm.totalData.yearRate >= 0 ? _c("div", {
    staticClass: "label label-1"
  }, [_vm._v("较去年增加"), _c("span", [_vm._v(_vm._s(_vm.totalData.yearRate) + "%")]), _vm.totalData.yearRate > 0 ? _c("img", {
    attrs: {
      src: require("./image/largeEnergy/add.png"),
      alt: ""
    }
  }) : _vm._e()]) : _c("div", {
    staticClass: "label label-2"
  }, [_vm._v("较去年减少"), _c("span", [_vm._v(_vm._s(Math.abs(_vm.totalData.yearRate)) + "%")]), _c("img", {
    attrs: {
      src: require("./image/largeEnergy/reduce.png"),
      alt: ""
    }
  })])])])])])]), _vm._m(3)]), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "item item-1"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("设备今日用电量")]), _c("div", {
    staticClass: "item-content",
    staticStyle: {
      "padding-bottom": "1.57vh",
      overflow: "auto"
    }
  }, _vm._l(_vm.device_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "opt opt-active"
    }, [_c("div", {
      staticClass: "img"
    }, [item.deviceImage ? _c("img", {
      attrs: {
        src: item.deviceImage,
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260805/1785921545187.png",
        alt: ""
      }
    })]), _c("div", {
      staticClass: "opt-content"
    }, [_c("div", {
      staticClass: "name"
    }, [_c("div", {
      staticClass: "label"
    }, [_c("div", {
      staticClass: "dot"
    }), _c("div", [_vm._v(_vm._s(item.deviceName || "--"))])]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.lastPowerRecord[item.activeEnergy]) + " "), _c("span", [_vm._v("kwh")])])]), _vm._m(4, true)])]);
  }), 0)]), _c("div", {
    staticClass: "right-bottom",
    staticStyle: {
      height: "50%",
      display: "flex"
    }
  }, [_vm._m(5), _c("div", {
    staticClass: "item",
    staticStyle: {
      width: "calc((100% - 2vw) / 3)",
      "margin-left": "1vw"
    }
  }, [_c("div", {
    staticClass: "title",
    staticStyle: {
      "background-size": "auto 100%"
    }
  }, [_vm._v("用电量调控建议")]), _c("div", {
    staticClass: "item-content proposal"
  }, [_c("div", _vm._l(_vm.proposal, function (item, key) {
    return _c("div", {
      key: key
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(key))]), _c("div", {
      staticClass: "times"
    }, _vm._l(item, function (opt, index) {
      return _c("div", {
        key: index
      }, [_vm._v(_vm._s(opt))]);
    }), 0)]);
  }), 0)])])])])]), _c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside2.png"),
      alt: ""
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "opt-left"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeEnergy/item-1-icon.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("今日用电量")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "opt-left"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeEnergy/item-1-icon.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("本月用电量")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "opt-left"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeEnergy/item-1-icon.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("今年用电量")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item item-2"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("日电量用电趋势")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "daily-trend-line"
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "line"
  }, [_c("div")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item",
    staticStyle: {
      width: "calc(((100% - 2vw)/3)*2 + 1vw)"
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("设备用电量趋势")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "equipment-trend-line"
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };